import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
const descriptionWithSlidesBlockSchema = Joi.object({
  type: Joi.string().valid('descriptionWithSlidesBlock').required(),
  code: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  descriptionColor: Joi.string().allow('', null).required(),
  link: linkSchema.allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  slides: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    title: Joi.string().allow('', null).required(),
    titleColor: Joi.string().allow('', null).required(),
    link: linkSchema.allow('', null).required(),
    image: mediaUrlSchema
  }).unknown(true)),
  voxboxButton: Joi.bool().allow(null).required()
}).unknown(true);
export default descriptionWithSlidesBlockSchema;